import FulfilmentsUtil from "../../utils/fulfilments-util";
import { R, toJSON, toNumber } from "../../utils/rational";
const util = new FulfilmentsUtil();

export default {
  data() {
    return {
      isDialogOpen: false,
      inputValue: "",
    };
  },
  methods: {
    findRowById(items, id) {
      if (!Array.isArray(items)) return null;
      for (const row of items) {
        if (row.id === id) return row;
        if (row.children && row.children.length) {
          const found = this.findRowById(row.children, id);
          if (found) return found;
        }
      }
      return null;
    },

    mouseLeave(item) {
      if (!this.isDialogOpen) {
        item.showEditDialog = false;
      }
    },

    open(openedCell) {
      this.isDialogOpen = true;
      this.inputValue = typeof openedCell === "object" ? toNumber(openedCell) : openedCell;
    },

    close1(item) {
      setTimeout(() => {
        this.isDialogOpen = false;
        item.showEditDialog = false;
      }, 500);
    },

    changeCell(item, headerValue) {
      const normalizedValue =
        headerValue === "weight" ? toJSON(R(Number(this.inputValue) || 0)) : this.inputValue;
      item[headerValue] = normalizedValue;
      item.showEditDialog = false;
      this.isDialogOpen = false;
      util.calculateRowFulfillment(item, this.steps);
      this.$store.dispatch("setDeliverables", this.deliverables);
    },

    changeHeader(header) {
      if (this.rules.required(this.inputValue.length) === true && this.rules.alreadyExist(this.inputValue) === true) {
        header.text = this.inputValue;
        this.$store.dispatch("setHeaders", this.headers);
      }
    },

    inputChanged(value, param) {
      if (param === "weight") {
        if (value !== "" && value > 0) {
          this.inputValue = Number(value);
        }
      } else {
        this.inputValue = value;
      }
    },

    headerTextFieldOpen(headerText) {
      this.inputValue = headerText;
      this.rules.alreadyExist = (value) => {
        return (
          !this.headers.find((header) => {
            return (
              value.toLowerCase() === header.text.toLowerCase() && value.toLowerCase() !== headerText.toLowerCase()
            );
          }) || "Column name already exist"
        );
      };
    },

    handleSelectChange(item, headerValue) {
      const steps = ["open", "wip", "closed", "n.rel."];
      const currentStepIndex = steps.indexOf(item[headerValue]);
      const nextStepIndex = (currentStepIndex + 1) % steps.length;

      this.$set(item, headerValue, steps[nextStepIndex]);

      if (!item.isChild) {
        util.calculateRowFulfillment(item, this.steps);
      }

      let parentRow = item.parentId !== undefined ? this.findRowById(this.deliverables, item.parentId) : null;
      while (parentRow) {
        this.calculateStepsFulfillmentForNewRow(parentRow);
        parentRow = parentRow.parentId !== undefined ? this.findRowById(this.deliverables, parentRow.parentId) : null;
      }

      util.recalculateAllFulfillments(this.deliverables, this.steps);
      this.$store.dispatch("setDeliverables", this.deliverables);
    },
  },
};
